import * as React from 'react'
import { ResourcesRecordShape, ResourcesAdjustmentShape } from '../../api/api_data_types'
import RecordItem from './RecordItem'
import AbsenceItem from './AbsenceItem'
import PresenceItem from './PresenceItem'
import AdjustmentItem from './AdjustmentItem'

type RecordsListProps = {
  records: ResourcesRecordShape[]
  absenceDay: ResourcesRecordShape | null
  presenceDay: ResourcesRecordShape | null
  adjustments: ResourcesAdjustmentShape[]
  date?: string
}

export default function RecordsList({
  records,
  absenceDay,
  presenceDay,
  adjustments,
  date,
}: RecordsListProps) {
  return (
    <ul className="time-entries">
      {absenceDay && (
        <li>
          <AbsenceItem record={absenceDay} />
        </li>
      )}
      {presenceDay && (
        <li>
          <PresenceItem record={presenceDay} />
        </li>
      )}
      {records.map(record => (
        <li key={`record-${record.id}`}>
          <RecordItem record={record} />
        </li>
      ))}
      {adjustments.map(adjustment => (
        <li key={`adjustment-${adjustment.id}`}>
          <AdjustmentItem adjustment={adjustment} />
        </li>
      ))}
    </ul>
  )
}
